import { useWidgetContext } from './WidgetContext';
import { sanitizeEmbedHtml } from 'rich-text-lib/utils/embedSrc';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const NoteWidgetBody = () => {
  const {
    report
  } = useWidgetContext();
  const text = report.getIn(['config', 'noteText']);
  const html = sanitizeEmbedHtml(text);
  return /*#__PURE__*/_jsx(ScrollContainer, {
    "data-test-id": "note-loaded",
    maxHeight: "100%",
    children: /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    })
  });
};
export default NoteWidgetBody;